export default __webpack_public_path__ + "static/hearts-right-840ce55a63a2843aa7f83bb409ccf09e.svg";